<template>
  <b-container fluid class="my-4 text-center">
      <h2 class="pt-4">Not Found</h2>
      <p class="lead">This page does not exist.</p>
  </b-container>
</template>

<script>
import SITES_QUERY from '@/graphql/SitesQuery.gql'
import {get} from 'lodash'

export default {
  name: 'dashboard',
  components: {},
  data: () => {
    return {
    }
  },

  watch: {
    '$route.name': {
      immediate: true,
      handler: async function() {
        if(this.$route.name != 'index') {
          return
        }
        let site_id = localStorage.site_id
        if(!site_id) {
          const resp = await this.$apollo.query({
            query: SITES_QUERY,
            variables: {
              score: process.env.VUE_APP_SCORE_HIGH
            }
          })
          site_id = get(resp, 'data.site[0].id')
        }
        if(site_id) {
          this.$router.replace({name: 'pages', params: {site_id}})
        }
      }
    }
  },
}
</script>

<style>
</style>
